import { makeLabels } from 'utils/i18n';

const NAMESPACE = 'pages.cryptoPayout.details.customer';
const LABELS = makeLabels(
  {
    TITLE: ['title', 'Customer'],
    CUSTOMER_EMAIL: ['userEmail', 'Customer Email'],
    CUSTOMER_ID: ['userId', 'Customer ID'],
    EXTERNAL_CUSTOMER_ID: ['externalUserId', 'External Customer ID'],
  },
  NAMESPACE,
);

export default LABELS;
